import { loanApplicationTagsAssignmentsApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { sortArrayByDate } from 'utils/data';

import { selectMasterCompanyId } from 'store/auth/selectors';

export const getLoanApplicationTagAssignmentsHistoryAction = catchAsyncActionError(
  ({ applicationId } = {}) =>
    async (dispatch, getState) => {
      const companyId = selectMasterCompanyId(getState());

      const { data } = await loanApplicationTagsAssignmentsApi.getLoanTagAssignmentsHistory({
        applicationId,
        companyId,
      });

      return sortArrayByDate(data, 'date', 'desc');
    },
);
